var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_897_39642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0909 11.6365H2.90909V12.3637H13.0909V11.6365Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4182 5.45463C11.7091 5.16372 11.7091 4.72736 11.4182 4.43645L10.1091 3.12736C9.81818 2.83645 9.38181 2.83645 9.09091 3.12736L3.63636 8.58191V10.9092H5.96363L11.4182 5.45463ZM9.6 3.63645L10.9091 4.94554L9.81818 6.03645L8.50909 4.72736L9.6 3.63645ZM4.36363 10.1819V8.87282L8 5.23645L9.30909 6.54554L5.67272 10.1819H4.36363Z",
    fill: "#161616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_897_39642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6364,
    height: 11.6364,
    fill: "white",
    transform: "translate(2.18182 2.18164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fe4dd9baa59e839138691f83be581b05.svg";
export { ForwardRef as ReactComponent };